import { render, staticRenderFns } from "./Invite-success.vue?vue&type=template&id=6da44e64&scoped=true";
import script from "./Invite-success.vue?vue&type=script&lang=js";
export * from "./Invite-success.vue?vue&type=script&lang=js";
import style0 from "./Invite-success.vue?vue&type=style&index=0&id=6da44e64&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "6da44e64", null);
export default component.exports;